module.exports = __webpack_public_path__ + "static/media/14a.58fb3fed.jpg";